import React, { useState, useEffect } from 'react';
import { DashboardContainer } from './DashboardInicio.styles';
import Navbar from '../../components/layout/Navbar/Navbar';
import Sidebar from '../../components/layout/Sidebar/Sidebar';
import BemVindoComponent from '../../components/Dashboard/BemVindoComponent';
import DashboardContent from '../../components/Dashboard/DashBoardContent';
import { getCargoIdSidebar } from '../../constants/sidebarConfig';
import apiService from '../../services/api';

const DashboardInicio = () => {
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await apiService.getCurrentUser();
        setUser(userData);
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error('Erro ao buscar usuário:', err);
      }
    };

    fetchUser();
  }, []);

  return (
    <DashboardContainer>
      <Navbar 
        onLogout={apiService.logout}
        showHome={true}
        showNotifications={true}
        showProfile={true}
        showLogout={true}
        user={user}
      />
      <Sidebar items={sidebarItems} />
      <main className="main-content">
        <BemVindoComponent />
        <DashboardContent cargoId={user?.cargoId} />
      </main>
    </DashboardContainer>
  );
};

export default DashboardInicio;